import styled from 'styled-components';

const Container = styled.div`
  height: 3px;
  width: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ProgressBar = styled.div`
  background-color: #e2e2e2;
  border-radius: 10px;
  height: 3px;
  width: 100%;
`;

const Progress = styled.div`
  background-color: #2685d0;
  width: 100%;
  height: 3px;
  transition: width 0s linear;
  animation-name: in-out;
  animation-duration: ${({ totalTime }) => totalTime / 1000}s;
  animation-timing-function: linear;

  @keyframes in-out {
    0% {
      width: 100%;
    }
    100% {
      width: 0;
    }
  }
`;

const Timer = ({ totalTime }) => (
  <Container>
    <ProgressBar>
      <Progress totalTime={totalTime} />
    </ProgressBar>
  </Container>
);

export default Timer;
